import React, { useState } from 'react'

// MUI
import {
  Grid, Typography, TextField, FormControl, Divider,
  Tabs, Tab, AppBar, Button
} from '@material-ui/core'

import { withStyles, makeStyles } from '@material-ui/core/styles'

import { TabPanel } from '../../../tools'

const learnsafeBlue = '#5291fc'
const learnsafeGreen = '#A4D164'

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: 'transparent',
    '& > span': {
      maxWidth: 60,
      width: '100%',
      backgroundColor: learnsafeBlue
    }
  }
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />)

const useStyles = makeStyles((theme) => ({
  tabBar: {
    backgroundColor: learnsafeGreen
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  }
}))

const a11yProps = (tabValue) => {
  return {
    id: `simple-tab-${tabValue}`,
    'aria-controls': `simple-tabpanel-${tabValue}`
  }
}

const CiscoConfiguration = (props) => {
  const { ciscoIntegrationForm, orgUnitInfo, onConfigure = () => { } } = props
  const classes = useStyles()

  const [tabValue, setTabValue] = useState('settings')

  return (
    <Grid container direction='row'>
      <Grid container item direction='column'>
        <Grid container item direction='row'>
          <Grid item xs>
            <AppBar position='relative' className={classes.tabBar}>
              <Grid container direction='row'>
                <Grid item xs>
                  <StyledTabs
                    value={tabValue}
                    centered
                    onChange={(e, newTab) => setTabValue(newTab)}
                  >
                    <Tab className='font-weight-bold' label='Settings' value='settings' {...a11yProps('settings')} />
                    <Tab className='font-weight-bold' label='Mappings' value='mappings' {...a11yProps('mappings')} />
                  </StyledTabs>
                </Grid>
              </Grid>
            </AppBar>
          </Grid>
        </Grid>

        <Grid item container direction='row'>
          <Grid item xs>
            <TabPanel index='settings' value={tabValue}>
              <Grid container direction='row'>
                <Grid item container direction='column' spacing={2} className='m-auto w-100'>
                  <Grid container item direction='row'>
                    <Grid item>
                      <Typography
                        variant='h6'
                        style={{ textTransform: 'none', fontWeight: 'bold' }}
                        className='text-primary mt-1'
                      >
                        Configuration Settings:
                      </Typography>
                    </Grid>
                  </Grid>

                  <Divider variant='middle' />

                  <Grid item container direction='row' justify='center'>
                    <Grid container item md={9} xs direction='column'>
                      <Typography variant='button' className='text-primary font-weight-bold'> Organization Setup:</Typography>
                      {/* <Typography gutterBottom variant='caption' style={{ textTransform: 'none' }} className='text-muted'> Test</Typography> */}
                      <TextField
                        style={{ textTransform: 'none' }}
                        value='Single Org'
                        variant='outlined'
                      />
                    </Grid>
                  </Grid>

                  <Grid item container direction='row' justify='center'>
                    <Grid container item md={9} xs direction='column'>
                      <Typography gutterBottom variant='button' className='text-primary font-weight-bold'> Organization ID:</Typography>
                      {/* <Typography gutterBottom variant='caption' style={{ textTransform: 'none' }} className='text-muted'> Test</Typography> */}
                      <TextField
                        style={{ textTransform: 'none' }}
                        value={ciscoIntegrationForm.summary.organizationID}
                        variant='outlined'
                      />
                    </Grid>
                  </Grid>

                  <Grid item container direction='row' justify='center'>
                    <Grid container item md={9} xs direction='column'>
                      <Typography gutterBottom variant='button' className='text-primary font-weight-bold'> Management API Key:</Typography>
                      {/* <Typography gutterBottom variant='caption' style={{ textTransform: 'none' }} className='text-muted'> Test</Typography> */}
                      <TextField
                        style={{ textTransform: 'none' }}
                        value={ciscoIntegrationForm.summary.apiKey}
                        variant='outlined'
                      />
                    </Grid>
                  </Grid>

                  <Grid item container direction='row' justify='center'>
                    <Grid container item md={9} xs direction='column'>
                      <Typography gutterBottom variant='button' className='text-primary font-weight-bold'> Management API Secret:</Typography>
                      {/* <Typography gutterBottom variant='caption' style={{ textTransform: 'none' }} className='text-muted'> Test</Typography> */}
                      <TextField
                        style={{ textTransform: 'none' }}
                        value={ciscoIntegrationForm.summary.apiSecret}
                        variant='outlined'
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </TabPanel>
          </Grid>
        </Grid>

        <Grid item container direction='row'>
          <Grid item xs>
            <TabPanel index='mappings' value={tabValue}>
              <Grid container direction='row'>
                <Grid item container direction='column' spacing={2} className='m-auto w-100'>
                  <Grid container item direction='row'>
                    <Grid item>
                      <Typography
                        variant='h6'
                        style={{ textTransform: 'none', fontWeight: 'bold' }}
                        className='text-primary mt-1'
                      >
                        OU Mappings:
                      </Typography>
                    </Grid>
                  </Grid>

                  <Divider variant='middle' />

                  {orgUnitInfo.map(unit => {
                    return (
                      <Grid key={`unit-map-${unit.unitID}`} item container direction='row' justify='center'>
                        <Grid item md={9} sm>
                          <FormControl fullWidth variant='filled'>
                            <Typography gutterBottom variant='button' className='text-primary font-weight-bold'>{unit.display}</Typography>
                            {/* <InputLabel htmlFor={`blocklist-label-${unit.unitID}`}>{unit.display}</InputLabel> */}
                            <TextField
                              value={
                                ciscoIntegrationForm && ciscoIntegrationForm.units && ciscoIntegrationForm.units[`${unit.unitID}`]
                                  ? ciscoIntegrationForm.units[`${unit.unitID}`].destinationListName
                                  : '--'
                              }
                              style={{ textTransform: 'none' }}
                              variant='outlined'
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    )
                  })}
                </Grid>
              </Grid>
            </TabPanel>
          </Grid>
        </Grid>

        <Divider variant='fullWidth' className='mt-2' />

        <Grid container item direction='row'>
          <Grid container item direction='column' alignItems='center' spacing={2} className='m-auto w-100'>
            <Grid item>
              <Typography variant='button' className='text-muted font-weight-bold'>Configure Your Organization's Cisco Umbrella Integration</Typography>
            </Grid>

            <Grid item>
              <Button
                variant='contained'
                onClick={onConfigure}
                className={classes.greenBtn}
              >
                Configure
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CiscoConfiguration
